import { render, staticRenderFns } from "./exhibition-home-project.vue?vue&type=template&id=45817ef2&scoped=true&"
import script from "./exhibition-home-project.vue?vue&type=script&lang=js&"
export * from "./exhibition-home-project.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-home-project.vue?vue&type=style&index=0&id=45817ef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45817ef2",
  null
  
)

export default component.exports